import { render, staticRenderFns } from "./add_surveyData.vue?vue&type=template&id=1856e4fc&scoped=true&"
import script from "./add_surveyData.vue?vue&type=script&lang=js&"
export * from "./add_surveyData.vue?vue&type=script&lang=js&"
import style0 from "./add_surveyData.vue?vue&type=style&index=0&id=1856e4fc&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1856e4fc",
  null
  
)

export default component.exports